import { motion } from 'framer-motion';
import { useAppStore } from '../stores/useAppStore';

const Page = ({ children, className = '', disableTransition = false, paddingLeftCollapsed = '7.5rem', paddingLeft = '7.5rem'}) => {
  const { fullScreen, sidebarCollapsed } = useAppStore();

  // Variants para la animación de opacidad (entrada y salida del componente)
  const opacityVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.3, ease: 'linear' } },
    exit: { opacity: 0, transition: { duration: 0.3, ease: 'linear' } }
  };

  return (
    <motion.div
      className="h-full w-full"
      variants={disableTransition ? {} : opacityVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <motion.div 
        className={`h-full ${className}`}
        animate={{
          paddingLeft: fullScreen ? 0 : (sidebarCollapsed ? paddingLeftCollapsed : paddingLeft),
          transition: { duration: 0.3, ease: 'linear' }
        }}
        initial={false} // Evita animación al montar
      >
        {children}
      </motion.div>
    </motion.div>
  );
};

export default Page;